
// import React, { useEffect, useState, useCallback } from "react";
// import axios from "../../api/axiosAuth";
// import ResponderTarea from "./ResponderTarea";
// import "../../style/TareasEstudiante.css";
// // 1. IMPORTAMOS LAS CONSTANTES CENTRALIZADAS
// import { API, UPLOADS_URL } from "../config"; 

// function TareasEstudiante() {
//   const [tareas, setTareas] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [tareaSeleccionada, setTareaSeleccionada] = useState(null);

//   const token = localStorage.getItem("token");

//   /* ==============================
//       🧠 UTILIDAD: ESTADO TAREA
//   ============================== */
//   const getEstadoTarea = (t) => {
//     if (t.respondida) return "Respondida";
//     if (t.due_date && new Date(t.due_date) < new Date()) return "Vencida";
//     return "Pendiente";
//   };

//   /* ==============================
//       📥 OBTENER TAREAS
//   ============================== */
//   const fetchTareas = useCallback(async () => {
//     try {
//       setLoading(true);
//       setError("");

//       if (!token) {
//         setError("Usuario no autenticado");
//         return;
//       }

//       // 2. CORREGIDO: Usamos ruta relativa. 
//       // axiosAuth ya inyecta el token y la IP de AWS automáticamente.
//       const res = await axios.get("/tasks/estudiante", {
//         withCredentials: true
//       });

//       const lista = Array.isArray(res.data) ? res.data : [];

//       setTareas(
//         lista.map(t => ({
//           id: t.id,
//           title: t.title,
//           description: t.description,
//           due_date: t.due_date,
//           materia: t.materia,
//           archivo: t.archivo,
//           respondida: Boolean(t.respondida)
//         }))
//       );
//     } catch (err) {
//       console.error("❌ Error cargando tareas:", err);
//       if (err.response?.status === 401) {
//         setError("Sesión expirada. Inicia sesión nuevamente.");
//       } else if (err.response?.data?.message) {
//         setError(err.response.data.message);
//       } else {
//         setError("No se pudieron cargar las tareas");
//       }
//       setTareas([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   /* ==============================
//       🧠 EFECTO INICIAL
//   ============================= */
//   useEffect(() => {
//     fetchTareas();
//   }, [fetchTareas]);

//   /* ==============================
//       🧭 RENDER
//   ============================== */
//   if (loading) return <p>⏳ Cargando tareas...</p>;
//   if (error) return <p style={{ color: "red" }}>❌ {error}</p>;

//   return (
//     <div className="tareas-wrapper">
//       <h2>📘 Mis Tareas</h2>

//       <div className="tareas-resumen">
//         <span>📦 Total: {tareas.length}</span>
//         <span style={{ color: "green" }}>
//           ✅ Respondidas: {tareas.filter(t => t.respondida).length}
//         </span>
//         <span style={{ color: "orange" }}>
//           ⏳ Pendientes: {tareas.filter(
//             t => !t.respondida && (!t.due_date || new Date(t.due_date) >= new Date())
//           ).length}
//         </span>
//         <span style={{ color: "red" }}>
//           ⛔ Vencidas: {tareas.filter(
//             t => !t.respondida && t.due_date && new Date(t.due_date) < new Date()
//           ).length}
//         </span>
//       </div>

//       {tareas.length === 0 && <p>No hay tareas asignadas</p>}

//       <table className="tareas-table">
//         <thead>
//           <tr>
//             <th>Título</th>
//             <th>Materia</th>
//             <th>Descripción</th>
//             <th>Fecha de Entrega</th>
//             <th>Archivo</th>
//             <th>Estado</th>
//             <th>Acción</th>
//           </tr>
//         </thead>
//         <tbody>
//           {tareas.map(t => {
//             const estado = getEstadoTarea(t);

//             return (
//               <tr key={t.id} className={`tarea-${estado.toLowerCase()}`}>
//                 <td>{t.title}</td>
//                 <td>{t.materia || "N/A"}</td>
//                 <td>{t.description || "Sin descripción"}</td>
//                 <td>{t.due_date ? new Date(t.due_date).toLocaleString() : "Sin fecha"}</td>
//                 <td>
//                   {/* 3. CORREGIDO: Usamos UPLOADS_URL para ver archivos de tareas */}
//                   {t.archivo && (
//                     <a href={`${UPLOADS_URL}${t.archivo}`} target="_blank" rel="noreferrer">
//                       📎 Ver archivo
//                     </a>
//                   )}
//                 </td>
//                 <td>{estado}</td>
//                 <td>
//                   {estado === "Pendiente" && (
//                     <button onClick={() => setTareaSeleccionada(t)}>✍️ Responder</button>
//                   )}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>

//       {tareaSeleccionada && (
//         <ResponderTarea
//           tarea={tareaSeleccionada}
//           onRespuestaEnviada={() => {
//             fetchTareas();
//             setTareaSeleccionada(null);
//           }}
//           onClose={() => setTareaSeleccionada(null)}
//         />
//       )}
//     </div>
//   );
// }

// export default TareasEstudiante;



///

import React, { useEffect, useState, useCallback } from "react";
import axios from "../../api/axiosAuth";
import ResponderTarea from "./ResponderTarea";
import "../../style/TareasEstudiante.css";
import { UPLOADS_URL } from "../config";

function TareasEstudiante() {
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [tareaSeleccionada, setTareaSeleccionada] = useState(null);

  /* ==============================
      🧠 ESTADO DE LA TAREA
  ============================== */

  const getEstadoTarea = (t) => {
    if (t.respondida) return "Respondida";

    if (t.due_date && new Date(t.due_date) < new Date()) {
      return "Vencida";
    }

    return "Pendiente";
  };

  /* ==============================
      📥 CARGAR TAREAS
  ============================== */

  const fetchTareas = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const { data } = await axios.get("/tasks/estudiante", {
        withCredentials: true,
      });

      console.log("📥 Respuesta backend:", data);

      // NUEVO FORMATO
      const lista = Array.isArray(data?.tareas)
        ? data.tareas
        : Array.isArray(data)
        ? data
        : [];

      console.table(lista);

      setTareas(
        lista.map((t) => ({
          id: t.id,
          title: t.title,
          description: t.description,
          due_date: t.due_date,
          materia: t.materia,
          archivo: t.archivo,
          profesor: t.profesor,
          estado: t.estado,
          respondida: Boolean(t.respondida),
        }))
      );
    } catch (err) {
      console.error("❌ Error cargando tareas:", err);

      setError(
        err.response?.data?.message ||
          "No fue posible cargar las tareas."
      );

      setTareas([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTareas();
  }, [fetchTareas]);

  if (loading) {
    return <div className="loading">⏳ Cargando tareas...</div>;
  }

  if (error) {
    return <div className="error">❌ {error}</div>;
  }

  return (
    <div className="tareas-wrapper">

      <h2>📚 Mis Tareas</h2>

      <div className="tareas-resumen">

        <span>
          📦 Total: <strong>{tareas.length}</strong>
        </span>

        <span style={{ color: "green" }}>
          ✅ Respondidas:{" "}
          <strong>
            {tareas.filter((t) => t.respondida).length}
          </strong>
        </span>

        <span style={{ color: "orange" }}>
          ⏳ Pendientes:{" "}
          <strong>
            {
              tareas.filter(
                (t) =>
                  !t.respondida &&
                  (!t.due_date || new Date(t.due_date) >= new Date())
              ).length
            }
          </strong>
        </span>

        <span style={{ color: "red" }}>
          ⛔ Vencidas:{" "}
          <strong>
            {
              tareas.filter(
                (t) =>
                  !t.respondida &&
                  t.due_date &&
                  new Date(t.due_date) < new Date()
              ).length
            }
          </strong>
        </span>

      </div>

      {tareas.length === 0 ? (
        <div className="sin-tareas">
          No tienes tareas asignadas.
        </div>
      ) : (
        <table className="tareas-table">

          <thead>

            <tr>
              <th>Título</th>
              <th>Materia</th>
              <th>Profesor</th>
              <th>Descripción</th>
              <th>Entrega</th>
              <th>Archivo</th>
              <th>Estado</th>
              <th>Acción</th>
            </tr>

          </thead>

          <tbody>

            {tareas.map((t) => {

              const estado = getEstadoTarea(t);

              return (
                <tr
                  key={t.id}
                  className={`tarea-${estado.toLowerCase()}`}
                >

                  <td>{t.title}</td>

                  <td>{t.materia || "-"}</td>

                  <td>{t.profesor || "-"}</td>

                  <td>{t.description || "-"}</td>

                  <td>
                    {t.due_date
                      ? new Date(t.due_date).toLocaleString()
                      : "-"}
                  </td>

                  <td>
                    {t.archivo ? (
                      <a
                        href={`${UPLOADS_URL}${t.archivo}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        📎 Ver archivo
                      </a>
                    ) : (
                      "—"
                    )}
                  </td>

                  <td>{estado}</td>

                  <td>
                    {!t.respondida && estado === "Pendiente" ? (
                      <button
                        onClick={() =>
                          setTareaSeleccionada(t)
                        }
                      >
                        ✍️ Responder
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>

                </tr>
              );
            })}

          </tbody>

        </table>
      )}

      {tareaSeleccionada && (
        <ResponderTarea
          tarea={tareaSeleccionada}
          onRespuestaEnviada={() => {
            fetchTareas();
            setTareaSeleccionada(null);
          }}
          onClose={() => setTareaSeleccionada(null)}
        />
      )}

    </div>
  );
}

export default TareasEstudiante;